// This file is generated - DO NOT EDIT DIRECTLY.
export const version = '1.28.0'
